// extracted by mini-css-extract-plugin
export default {"PrivacyTerms":"privacy-terms_PrivacyTerms__9trgi","Confirmation":"privacy-terms_Confirmation__Wy1Vl"};